module.exports = __webpack_public_path__ + "img/stop-d.fa1514d2.png";